import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cssload-wraper"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "cssload-dots" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PortalHeader = _resolveComponent("PortalHeader")!
  const _component_routerView = _resolveComponent("routerView")!
  const _component_PortalFooter = _resolveComponent("PortalFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(['wrapper', 'flex-column', _ctx.isMobile ? 'mobile' : 'desktop'])
    }, [
      _createVNode(_component_PortalHeader, { headerData: _ctx.headerData }, null, 8, ["headerData"]),
      _createElementVNode("main", null, [
        _createVNode(_component_routerView)
      ]),
      _createVNode(_component_PortalFooter, { footerData: _ctx.footerData }, null, 8, ["footerData"])
    ], 2),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true)
  ], 64))
}